export enum LogicOperator {
  And = 'and',
  Or = 'or',
}
